<template>

    <div class="expertpqces-container">
        <div class="left">
            <vggrid ref="xGrid" class="vggrid" :list="pusComList"
                    :cols="cols"
                    :showfooter="false"
                    :showPage="false" :resizable="true"
                    @cellClick="cellClick">
            </vggrid>
        </div>
        <div class="right" v-if="psu">

            <div class="right-grid">
                <vggrid :list="pgList" ref="pgGrid" flexname="" :cols="pgCols" :canbeEdit="isEdit?true : false"
                        :showfooter="false" :showPage="false" :resizable="true" :mergeRow='mergeRow'
                        :editRules="isEdit ? editRules : {}" :edit_config="{showIcon: isEdit?true : false}"
                >
                    <template slot="btn">
                        <div class="right-template">
                            <div class="right-container">
                                <div class="right-label">供应商：</div>
                                <div class="right-value">{{psu.comfullname}}</div>
                                <div class="right-label">评审文件：</div>
                                <div class="right-value"><span @click="downFile(psu.appendurl)">{{psu.appendfilename}}</span></div>
                            </div>
                        </div>
                    </template>
                </vggrid>
            </div>
            <div v-if="pgList.length">
                <div class="right-box">
                    <div class="right-container">
                        <div class="right-label">分值：</div>
                        <div class="right-value">{{total}}</div>
                        <div class="right-label">评分意见：</div>
                        <div  class="right-content" v-if="isEdit">
                            <el-input v-model="psu.pgsdesc" type="textarea" :maxlength="255" show-word-limit></el-input>
                        </div>
                        <div class="right-content"  v-if="!isEdit">
                            {{pgsdesc}}
                        </div>
                        <div class="right-btn"  v-if="isEdit">
                            <vxe-button type='primary' class="vxe-btn" @click="save" :loading="btnLoading">保存</vxe-button>
                        </div>
                    </div>
                </div>
                <div class="right-grid">
                    <vggrid :list="pgsList" flexname="" :cols="pgsCols"
                            :showfooter="false" :showPage="false" :resizable="true"
                    >
                        <template slot="btn">
                            <div class="right-bottom">
                                <div class="right-bottom-title">我的评分汇总</div>
                                <div class="right-bottom-btn" v-if="isEdit">
                                    <vxe-button type='primary' class="vxe-btn" @click="submit" :loading="btnLoading">提交</vxe-button>
                                </div>
                            </div>
                        </template>
                    </vggrid>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
  import request from '@/utils/request'
  import vggrid from '../../views/common/vggrid'
  import common from '@/mixin/common'
  import utils from '../../assets/js/utils'

  export default {
    name: 'exPqcCheckComIndex',
    props: {
      activeName: {}
    },
    mixins: [common],
    data () {
      return {
        pgList: [],
        pgsList: [],
        project: {},
        btnLoading: false,
        isEdit: true,
        mergeRow:['ind','pgratio','pgparentname','pgchildname'],
        pgsCols: [
          {field: 'comfullname', fieldtype: 'C', title: '投标人', calculExpr: '', addNewRowFlg: false},
          // {field: 'pgspriceasexchange', fieldtype: 'C', title: '价格得分', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pgscommercialasexchange', fieldtype: 'C', title: '评审得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgstechnologyasexchange', fieldtype: 'C', title: '技术得分', calculExpr: '', addNewRowFlg: false, width: 100},
          // {field: 'pgsas', fieldtype: 'C', title: '总分', calculExpr: '', addNewRowFlg: false, width: 100},
          {field: 'pgsdesc', fieldtype: 'C', title: '评分意见', calculExpr: '', addNewRowFlg: false},
        ],
        pgCols: [],
        editRules: {
          'pgsuas': [
            {required: true, message: '请对投标人评分！'}
          ]
        },
        cols: [
          {type: 'index', fieldtype: 'I', title: '行号', calculExpr: '', width: 50},
          {field: 'comfullname', fieldtype: 'C', title: '供应商', calculExpr: '', addNewRowFlg: false, width: 200}
        ],
        pusComList: [],
        psu: {}
      }
    },
    // deactivated () {
    //   this.$destroy()
    // },
    async created () {
      await this.getModel()
      await this.getPsuComList()
    },
    activated () {
      // this.getPsuComList()
    },
    mounted () {
    },
    watch: {
      activeName () {
        if(this.activeName === 'agyszy') {
          this.getPsuComList()
        }
      }
    },
    components: {vggrid},
    methods: {
      // 评分汇总表的提交
      async submit () {
        let index1 = this.pgsList.findIndex(v => +v.psupricecommit !== 1)
        if (index1 > -1) {
          this.$message.warning('项目员未录入提交价格分，请耐心等候!')
          return
        }
        // 提取所有psuid，转换为逗号分隔的字符串
        const psuIds = this.pusComList.map(item => item.psuid).join(',');
        let res = await request({
          method: 'get',
          url: '/expert/getPgsListBy',
          params: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            psuids: psuIds
          }
        })
        if (res.length) {
          let index = res.findIndex(v => !v.pgsuas)
          if (index > -1) {
            this.$message.warning('请对供应商评分并且保存后再提交!')
            return
          }
        }
        this.$confirm('评分完成，提交后，不允许再次评分?', '提示', {
          confirmButtonText: '是',
          cancelButtonText: '否',
          type: 'warning'
        }).then(async() => {
          let data = await request({
            url: 'expert/insertPgs',
            method: "post",
            data: {
              pexpertid: this.$store.getters.expertLoginUser.pexpertid,
              projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
              list: this.pgsList
            }
          })
          if (data.issuccess === 1) {
            this.$message.success('保存成功')
            this.isEdit = false
            this.$emit('change')
          } else {
            this.$message.error('保存失败')
          }
        })
      },
      // 供应商评分保存
      async save () {
       let index = this.pgList.findIndex(v => v.pgsuas === "")
        if (index > -1) {
          this.$message.warning('供应商得分不能为空！')
          return
        }
        let data = await request({
          url: 'expert/updatePgsu',
          method: "post",
          data: {
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            list: this.pgList
          }
        })
        this.scoreTotalList = data.totalList
        if (data.issuccess === 1) {
          this.$message.success('保存成功')
          this.pgsList.forEach(async v => {
            if (+v.pgscomid === +this.psu.psucomid) {
              // v.pgsas = this.total
              v.pgsdesc = this.psu.pgsdesc
              v.psupricecommit = this.psu.psupricecommit
              v.comid = v.pgscomid
              let total = await this.getScoreTotalList(v)
              v.pgspriceas = total.pgspriceas
              v.pgspriceasexchange = total.pgspriceasexchange
              v.pgscommercialas = total.pgscommercialas
              v.pgscommercialasexchange = total.pgscommercialasexchange
              v.pgstechnologyas = total.pgstechnologyas
              v.pgstechnologyasexchange = total.pgstechnologyasexchange
              v.pgsas = (Number(total.pgspriceasexchange) + Number(total.pgscommercialasexchange) + Number(total.pgstechnologyasexchange)).toFixed(2)
            }
          })
        } else {
          this.$message.error('保存失败')
        }
      },
      async getModel () {
        let res = await request({
          method: 'get',
          url: 'expert/findProjectById',
          params: {projectid: this.$store.getters.expertLoginUser.pexpertprojectid}
        })
        this.project = res
      },
      //供应商清单数据
      async getPsuComList () {
        this.psu = ''
        let project = {}
        project.projectisqcheck = this.project.projectisqcheck
        let res = await request({
          url: 'expert/getPsuListByPIdHaveAppend',
          method: "get",
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid,
            psupqcesresult: 1,
            projectisqcheck: this.project.projectisqcheck
          }
        })
        this.pusComList = res.data
        this.scoreTotalList = res.totalList
        this.psu = this.pusComList[0]
        this.$refs.xGrid.$refs.xGrid.setCurrentRow(this.psu)
        await this.getPgCrossList()
        await this.setPgsList()
      },
      // 返回价格分商务分技术分的原始分及转换后的分数
      async getScoreTotalList (v) {
        let priceModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.comid && t.parentname === '价格')
        let commercialModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.comid && t.parentname === '评审')
        let technologyModel =  this.scoreTotalList.find(t => +t.pgsucomid === +v.comid && t.parentname === '技术')
        let pgspriceas = 0
        let pgscommercialas = 0
        let pgstechnologyas = 0
        let price_pgratio = 0
        let commercial_pgratio = 0
        let technology_pgratio = 0
        let price_pgscorestotal = 0
        let commercial_pgscorestotal = 0
        let technology_pgscorestotal = 0
        // 价格
        if (priceModel) {
          // 权重
          price_pgratio = priceModel.pgratio
          // 原始分
          pgspriceas = priceModel.pgsuastotal
          // 分值总分
          price_pgscorestotal = priceModel.pgscorestotal
        }
        // 商务
        if (commercialModel) {
          // 权重
          commercial_pgratio = commercialModel.pgratio
          // 原始分
          pgscommercialas = commercialModel.pgsuastotal ? commercialModel.pgsuastotal : 0
          // 分值总分
          commercial_pgscorestotal = commercialModel.pgscorestotal
        }
        // 技术
        if (technologyModel) {
          // 权重
          technology_pgratio = technologyModel.pgratio
          // 原始分
          pgstechnologyas = technologyModel.pgsuastotal ? technologyModel.pgsuastotal : 0
          // 分值总分
          technology_pgscorestotal = technologyModel.pgscorestotal
        }
        // 价格/商务/技术的转换分：
        // 转换公式（分值/分值总分）*权重
        let pgspriceasexchange = ((Number(pgspriceas)/100)*Number(price_pgratio))
        let pgscommercialasexchange = Number(commercial_pgscorestotal) > 0 ? ((Number(pgscommercialas)/Number(commercial_pgscorestotal))*Number(commercial_pgratio)) : 0
        let pgstechnologyasexchange = Number(technology_pgscorestotal) > 0 ? ((Number(pgstechnologyas)/Number(technology_pgscorestotal))*Number(technology_pgratio)) : 0
        return {
          pgspriceas,
          pgspriceasexchange: pgspriceasexchange.toFixed(2),
          pgscommercialas,
          pgscommercialasexchange: pgscommercialasexchange.toFixed(2),
          pgstechnologyas,
          pgstechnologyasexchange:pgstechnologyasexchange.toFixed(2)
        }
      },
      async setPgsList () {
        await this.getPgsList()
        if (this.pgsList.length) {
          this.isEdit = false
        } else {
          this.isEdit = true
          this.pgsList = []
          this.pusComList.forEach(async v => {
            // 构造pgsrec-评审人对供应商的评分表的数据
            let total = await this.getScoreTotalList(v)
            // console.log(total)
            this.pgsList.push({
              psuid: v.psuid,
              pgscomid: v.psucomid,
              psupricecommit: v.psupricecommit,
              comfullname: v.comfullname,
              pgsprojectid: v.psuprojectid,
              pgspriceas: total.pgspriceas,
              pgspriceasexchange: total.pgspriceasexchange,
              pgscommercialas: total.pgscommercialas,
              pgscommercialasexchange: total.pgscommercialasexchange,
              pgstechnologyas: total.pgstechnologyas,
              pgstechnologyasexchange: total.pgstechnologyasexchange,
              pgsas: (Number(total.pgspriceasexchange) + Number(total.pgscommercialasexchange) + Number(total.pgstechnologyasexchange)).toFixed(2),
              pgsexpertid: this.$store.getters.expertLoginUser.pexpertid,
              pgsdesc: null
            })
          })
        }
      },
      // 汇总表的数据
      async getPgsList () {
        this.pgsList = await request({
          url: 'expert/getPgsByProjectId',
          method: "get",
          params: {
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
      },
      // 供应商清单行点击
      async cellClick (row) {
        this.psu = row.row
        await this.getPgCrossList()
      },
      // 右边检查项清单数据
      async getPgCrossList () {
        await this.getPgCols()
        this.loading = true
        let res = await request({
          method: 'get',
          url: 'expert/getComPgList',
          params: {
            comid: this.psu.psucomid,
            pexpertid: this.$store.getters.expertLoginUser.pexpertid,
            projectid: this.$store.getters.expertLoginUser.pexpertprojectid
          }
        })
        // this.pgList = res
        this.pgList = res.filter(v => +v.pgflg === 2)
        this.loading = false
      },
      inputChange (row, e) {
        // let float = /^([+-]?)\d*\.\d+$|(^[0-9]\d*$)/
        let float = /^(\d{1,2}(\.\d{1})?|100)$/
        if (e.target.value && !(float.test(e.target.value))) {
          this.$message.warning('请输入正确的得分，只保留一位小数！')
          e.target.value = ''
          return
        }
        if (Number(e.target.value) > Number(row.pgscore)) {
          this.$message.warning('供应商得分不能大于该项分值！')
          e.target.value = ''
          return
        }
        row.pgsuas = e.target.value
        // let total = this.getScoreTotalList(row)
        // row.pgspriceas=total.pgspriceas
        // row.pgspriceasexchange=total.pgspriceasexchange
        // row.pgscommercialas=total.pgscommercialas
        // row.pgscommercialasexchange=total.pgscommercialasexchange
        // row.pgstechnologyas=total.pgstechnologyas
        // row.pgstechnologyasexchange=total.pgstechnologyasexchange
      },
      getPgCols () {
        if (+this.project.projectpgstotalrule === 2) {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'C', title: '分值(绝对值)', calculExpr: '',width: 100},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: '',width: 120},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '',width: 80},
            { title: '得分 ', width: 100, showOverflow: true,
              slots: {
                default: 'default',width: 80,
                default: ({row}) => {
                  if (this.isEdit && +row.pgflg === 2) {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                    value={row.pgsuas}  onChange={this.inputChange.bind(this, row)}></input>
                  ]
                  } else {
                    return row.pgsuas
                  }
                }
              }
            }
            // {
            //   field: 'pgsuas', fieldtype: 'C', title: '得分', calculExpr: '', editRender: { name: 'input'}
            // }
          ]
        } else {
          this.pgCols = [
            // {field: 'pgparentname', fieldtype: 'C', title: '项目', calculExpr: ''},
            // {field: 'pgratio', fieldtype: 'C', title: '分值(百分比绝对值)', calculExpr: ''},
            {field: 'pgchildname', fieldtype: 'C', title: '一级（项目）', calculExpr: '',width: 120},
            {field: 'pgchildchildname', fieldtype: 'C', title: '二级（评审内容）', calculExpr: ''},
            {field: 'pgremark', fieldtype: 'C', title: '评分档次及依据', calculExpr: ''},
            {field: 'pgscore', fieldtype: 'C', title: '分值', calculExpr: '',width: 80},
            { title: '得分 ', width: 100, showOverflow: true,
              slots: {
                default: 'default',width: 80,
                default: ({row}) => {
                  if (this.isEdit && +row.pgflg === 2) {
                    return [
                      <input style="width: 100%;height: 30px;box-sizing: border-box;border-radius: 4px;border: 1px solid #DCDFE6;color: #606266;display: inline-block;padding: 0 5px;"
                    value={row.pgsuas}  onChange={this.inputChange.bind(this, row)}></input>
                  ]
                  } else {
                    return row.pgsuas
                  }
                }
              }
            }
          ]
        }
      }
    },
    filters: {},
    computed: {
      total () {
        let total = this.pgList.length ? this.pgList.map(t => Number(t.pgsuas)).reduce((a, b) => a + b) : 0
        // projectpgstotalrule综合评分法的总分规则（1：百分比；2：绝对值）
        if (+this.project.projectpgstotalrule === 1) {
          total = (Number(total)*Number(total/100)).toFixed(2)
        }
        return total
      },
      pgsdesc () {
        let model = this.pgsList.find(v => +v.pgscomid === +this.psu.psucomid && +v.pgsprojectid===+this.psu.psuprojectid)
        if (model) {
          return model.pgsdesc
        } else {
          return ''
        }
      }
    }
  }
</script>
<style lang="scss">
    .expertpqces-container {
        display: flex;
        .left {
            width: 250px;
            margin-right: 15px;
        }
        .right {
            flex: 1;
            .right-template {
                padding-left: 10px;
                .right-container {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .right-value {
                        padding: 0 50px 0 0;
                        color: #999999;
                        span {
                            display: block;
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                }
            }
            .right-box {
                border: 1px solid #E4E7ED;
                border-radius: 2px;
                padding: 15px;
                margin-bottom: 20px;
                .right-container {
                    font-size: 14px;
                    display: flex;
                    align-items: center;
                    .right-label {

                    }
                    .right-value {
                        padding: 0 50px 0 0;
                        color: #999999;
                        span {
                            display: block;
                            color: #409EFF;
                            cursor: pointer;
                        }
                    }
                    .right-content {
                        width: 500px;
                        color: #999999;
                    }
                    .right-btn {
                        padding-left: 20px;
                    }
                }
            }
            .right-grid{
                padding-bottom: 20px;
            }
            .right-bottom {
                display: flex;
                align-items: center;
                .right-bottom-title {
                    padding-left: 10px;
                    text-align: center;
                }
                .right-bottom-btn {
                    padding-left: 20px;
                }
            }
        }
    }
</style>
